import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

import { Button, Tooltip } from 'reactstrap';

const Footer = ({ clickNextDisabled, tooltipText, previousButtonText, onPreviousClick, onNextClick }) => {
  const buttonRef = useRef(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <footer className={"mt-3"}>
      <Button
        className="position-absolute"
        color={'secondary'}
        onClick={(event) => onPreviousClick(event)}
      >
        {previousButtonText}
      </Button>
      <Button
        color={'primary'}
        onClick={(event) => {
          clickNextDisabled ? event.preventDefault() : onNextClick(event);
        }}
        innerRef={buttonRef}
        className={classNames("pull-right", { "disabled": clickNextDisabled })}
      >
        Next
      </Button>

      {clickNextDisabled &&
      <Tooltip
        placement="bottom"
        trigger="hover"
        target={buttonRef}
        isOpen={tooltipOpen}
        toggle={() => setTooltipOpen(!tooltipOpen)}
      >
        {tooltipText}
      </Tooltip>
      }
    </footer>
  );
};

Footer.propTypes = {
  clickNextDisabled: PropTypes.bool.isRequired,
  tooltipText: PropTypes.string.isRequired,
  previousButtonText: PropTypes.string.isRequired,
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired
};

export default Footer;
